// extracted by mini-css-extract-plugin
export default {"App":"DeleteUser_App__Bw2ty","confirmDelete":"DeleteUser_confirmDelete__zFXCS"};